"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.formatPhoneNumber = function (number) {
  if (number.length === 10) {
    return "(" + number[0] + number[1] + number[2] + ") " + number[3] + number[4] + number[5] + "-" + number[6] + number[7] + number[8] + number[9];
  }

  return number;
};